<template>
  <div id="app">
    <transition name="fade">
      <div v-if="$auth.ready()">
        <main role="main" class="main-content" v-if="$auth.check()">
          <app-menu></app-menu>
          <router-view/>
          <a class="back-top" id="back-top" href="#top" v-if="backToTopVisible" @click.prevent="backToTop"></a>
        </main>
        <router-view v-if="!$auth.check()"/>
        <app-footer v-if="isLoaded"></app-footer>
      </div>
    </transition>
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
  import appFooter from '@/components/layout/Footer.vue'
  import appHeader from '@/components/layout/Header.vue'
  import appMenu from '@/components/layout/Menu.vue'

  export default {
    name: 'app',
    components: {
      appHeader,
      appFooter,
      appMenu
    },
    data () {
      return {
        backToTopVisible: false
      }
    },
    computed: {
      isLoaded () {
        return this.$store.getters.isLoaded
      }
    },
    methods: {
      backToTop () {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      },
      catchScroll () {
        this.backToTopVisible = (window.pageYOffset > 100)
      }
    },
    mounted () {
      window.smoothscroll = () => {
        let currentScroll = document.documentElement.scrollTop || document.body.scrollTop
        if (currentScroll > 0) {
          window.requestAnimationFrame(window.smoothscroll)
          window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)))
        }
      }
      window.addEventListener('scroll', this.catchScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.catchScroll)
    }
  }
</script>

<style lang="scss">
  @import "./styles/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue